import React from 'react';

import { useFormContext } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Alert, TitleWithDescription, InfoBox, LbSwitch } from '@infoods/lifebase-ui';
import { InbodyInfo } from './InbodyInfo/InbodyInfo';
import { EntityInbodyKeyTable } from './EntityInbodyKeyTable/EntityInbodyKeyTable';
import { useEntityInbodyKey } from '../../../hooks/useEntityInbodyKey';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { DisabledSelectInfo } from '../component/DisabledSelectInfo/DisabledSelectInfo';
import { inbodyTypeOptions } from '../../../../shared/constants/inbody-info/InbodyType';
import { EntityInbodyDataFormValue } from '../EntityInbodyDataConfig.settings';

type InbodyWidgetProps = {
  entityId: number;
};
/**
 * allowInbodyUsers can't be unselect if it's selected ones
 * be default all new-flow-2024 entities should have allowInbodyUsers = true, and it can't be unselect
 *
 * Only super admin and inbody admin can change inbody config
 *
 * If this logic will be changed, we need return disabled unselect allowInbodyUsers when inbodyKeys is not empty (allowInbodyUsers && inbodyKeys.length > 0)
 */
const InbodyWidget = observer(({ entityId }: InbodyWidgetProps) => {
  const { control, watch } = useFormContext<EntityInbodyDataFormValue>();

  const { isSuperAdmin, isInbodyAdmin } = loggedInUserDataStore;
  const canEditInbodyData = isSuperAdmin || isInbodyAdmin;

  const inbodyKeysMethods = useEntityInbodyKey(entityId);

  const isAllowInbodyUsers = watch('allowInbodyUsers');

  const SwitchTitle = (
    <LbSwitch
      control={control}
      name="allowInbodyUsers"
      label={
        <TitleWithDescription
          title="InBody machine configuration"
          description="Turn on switcher and select type of InBody machine"
        />
      }
      align="start"
      disabled={isAllowInbodyUsers || !canEditInbodyData}
    />
  );

  return (
    <InfoBox title={SwitchTitle} hideConfig={{ show: isAllowInbodyUsers }}>
      {canEditInbodyData ? (
        <>
          <InbodyInfo control={control} />
          <EntityInbodyKeyTable {...inbodyKeysMethods} />
        </>
      ) : (
        <div>
          <DisabledSelectInfo
            name="supportedInbodyType"
            label="InBody:"
            options={inbodyTypeOptions}
          />
          <Alert severity="info" size="small" data-test-id="lb-alert">
            If you want to reconnect InBody or update any information, please contact our
            support team.
          </Alert>
        </div>
      )}
    </InfoBox>
  );
});

export { InbodyWidget };
